export default "__VITE_ASSET__aTQXFB$f__"